<template>
<div>
  <el-dialog title="导入 SSH Known Hosts" :visible.sync="visible" width="600px" :close-on-click-modal="false" @closed="hide">
    <div>
      <el-input
          id="ssh-known-hosts-import"
          type="textarea"
          placeholder="请粘贴 SSH Known Hosts 文本内容, linux 或 mac os 一般可以从 ~/.ssh/known_hosts 复制, windows 自求多福"
          v-model="hosts"
          :maxlength="1024*1024*10"
          show-word-limit
          :autosize="{ minRows: 8, maxRows: 22 }"
      >
      </el-input>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="mini" @click="hide" type="primary">关闭</el-button>
      <el-button v-if="!posting" size="mini" @click="importHosts" type="primary">导入</el-button>
      <el-button v-if="posting" size="mini" type="primary" />
    </span>
  </el-dialog>
</div>
</template>

<script>
export default {
  name: "import",
  data() {
    return {
      visible: false,
      hosts: "",
      posting: false,
    }
  },
  methods: {
    show: function() {
      this.visible = true
      this.utils.domFocusById('ssh-known-hosts-import')
    },
    hide: function() {
      this.visible = false
      this.$emit('closed')
    },
    importHosts: function() {
      let self = this
      self.posting = true
      self.api.ssh.postSshKnownHosts(self.hosts, (error, data, response) => {
        self.posting = false
        if (error) {
          self.api.errHandler(self, error, response)
          return
        }
        self.$message.success("导入成功")
        self.$emit('success')
        self.hide()
      })
    },
  },
}
</script>

<style scoped>

</style>
